import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";

import LoggedInNavBlue from "../layout/IME/LoggedInNavBlue";
import LoggedOutNav from "../layout/IME/LoggedOutNav";
import TwoFARequest from "../layout/Innovators/TwoFARequest";
import LiveJobSearchInputs from "../layout/Employers/LiveJobSearchInputs";
import LiveJobsFeature from "../layout/Employers/LiveJobsFeature";
import JobMiniStream from "../layout/Employers/JobMiniStream";

const LiveOnIMEJobs = ({
  auth: { user, channelid, jobtitle, location, verified },
  isAuthenticated,
}) => {
  const [view, setView] = useState({
    livestreams: true,
    streams: false,
  });
  const [showAuthentication, setShowAuthentication] = useState(true);

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {verified && !isAuthenticated && (
        <TwoFARequest
          setShowAuthentication={setShowAuthentication}
          channelid={channelid}
          jobtitle={jobtitle}
          location={location}
        />
      )}
      {isAuthenticated && <LoggedInNavBlue />}
      {!isAuthenticated && <LoggedOutNav />}
      <div className="flex-all-content-fixed">
        <LiveJobSearchInputs />
        <LiveJobsFeature />
        <div className="active-view-live-ime">
          <div
            onClick={() => setView({ livestreams: true, streams: false })}
            className="section-title blue"
          >
            Live Streams
            {view.livestreams && (
              <i className="far fa-check-circle mx-5 blue"></i>
            )}
          </div>
          <div
            onClick={() => setView({ livestreams: false, streams: true })}
            className="section-title blue"
          >
            All Streams
            {view.streams && <i className="far fa-check-circle mx-5 blue"></i>}
          </div>
        </div>
        <section className="results">
          <div className="live-results">
            <div className="results-section-items blue">
              <p className="results-p">
                {user && user.role !== "employer" && (
                  <span className="white">{user.jobtitle}</span>
                )}
                <br />
                {user.location ? "Near" : "Recommended"}
                <span className="white mx-5">
                  {user.location && user.location.city}{" "}
                  {user.location && user.location.state}
                </span>
              </p>
            </div>
          </div>
          <hr className="background-blue" />
          <div className="created-content">
            <div className="content-container">
              <div className="stream-result">
                <Link to="/liveonime/employers/stream_id">
                  <JobMiniStream />
                </Link>
              </div>
            </div>
            <div className="content-container">
              <div className="stream-result">
                <Link to="/liveonime/employers/stream_id">
                  <JobMiniStream />
                </Link>
              </div>
            </div>
            <div className="content-container">
              <div className="stream-result">
                <Link to="/liveonime/employers/stream_id">
                  <JobMiniStream />
                </Link>
              </div>
            </div>
            <div className="content-container">
              <div className="stream-result">
                <Link to="/liveonime/employers/stream_id">
                  <JobMiniStream />
                </Link>
              </div>
            </div>
            <div className="content-container">
              <div className="stream-result">
                <Link to="/liveonime/employers/stream_id">
                  <JobMiniStream />
                </Link>
              </div>
            </div>
            <div className="content-container">
              <div className="stream-result">
                <Link to="/liveonime/employers/stream_id">
                  <JobMiniStream />
                </Link>
              </div>
            </div>
            <div className="content-container">
              <div className="stream-result">
                <Link to="/liveonime/employers/stream_id">
                  <JobMiniStream />
                </Link>
              </div>
            </div>
            <div className="content-container">
              <div className="stream-result">
                <Link to="/liveonime/employers/stream_id">
                  <JobMiniStream />
                </Link>
              </div>
            </div>
            <div className="content-container">
              <div className="stream-result">
                <Link to="/liveonime/employers/stream_id">
                  <JobMiniStream />
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(LiveOnIMEJobs);
